export default class PostsForm {
    constructor() {
        if (this.form === null) return;
        if (this.results === null) return;

        this.registerEvents();
    }
    // ------------------------------
    // Private methods
    private registerEvents() {
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();
            this.submitForm(false);
        });
        this.form.addEventListener("change", (e) => {
            if (e.target instanceof HTMLSelectElement) this.submitForm(false);
        });
    }
    private submitUrl(noFilters: boolean) {
        const regex = /\/page\/\d+/;

        const url = new URL(
            window.location.origin + window.location.pathname.replace(regex, ""),
        );
        url.searchParams.delete("paged");

        if (noFilters) return url;

        const formData = new FormData(this.form);
        for (const [key, value] of formData.entries()) {
            if (value !== "") {
                url.searchParams.append(key, value.toString());
            }
        }
        return url;
    }
    private syncQueryParams(url: URL) {
        const regex = /\/page\/\d+/;

        const newLocation = new URL(
            window.location.origin + window.location.pathname.replace(regex, ""),
        );
        newLocation.search = url.search;
        window.history.replaceState({}, "", newLocation.href);
    }
    private updateLoadingState(state: boolean) {
        const loading = document.getElementById("post-form-loading");
        if (loading === null) return;
        if (state) {
            loading.classList.remove("hidden");
            return;
        }
        loading.classList.add("hidden");
    }
    // ------------------------------
    // Public methods
    async submitForm(noFilters: boolean ) {
        try {
            
            const url = this.submitUrl(noFilters);
            this.updateLoadingState(true);

            const response = await fetch(url.href, {
                method: "GET",
                headers: {
                    "Content-Type": "text/html",
                },
            });
            const body = await response.text();
    
            const parser = new DOMParser();
            const doc = parser.parseFromString(body, "text/html");
            const jobResults = doc.getElementById("post-results");
            if (jobResults === null) {
                throw new Error("Results not found");
            }
    
            this.results.innerHTML = jobResults.innerHTML
    
            this.syncQueryParams(url)
            this.updateLoadingState(false);
        }
        catch (error) {
            this.updateLoadingState(false);
            console.error(error)
        }
    }
    // ------------------------------
    // getters
    get form() {
        return document.getElementById("post-form") as HTMLFormElement;
    }
    get results() {
        return document.getElementById(
            "post-results",
        ) as HTMLOutputElement;
    }
}
